'use strict';

goog.provide("Ntry.EventHandler")

Ntry._events = {};

Ntry.addEventListener = function(name, caller, func) {
    var event = {
        name: name,
        caller: caller,
        func: func
    }
    if (this._events[name] == null)
        this._events[name] = [];
    this._events[name].push(event);
    return event;
}

Ntry.removeEvent = function(event) {
    var eventList = this._events[name];
    var index = eventList.indexOf(event);
    if (index > -1)
        eventList.splice(index, 1);
}

Ntry.dispatchEvent = function(eventName) {
    var eventList = this._events[eventName];
    var args = Array.prototype.slice.call(arguments);
    args.shift();
    for (var i in eventList) {
        var event = eventList[i];
        event.func.apply(event.caller, args);
    }
}
